import { signInWithPopup } from 'firebase/auth';
import React, { useEffect } from 'react';
import { auth, db, provider } from '../utils/firebase';
import { useNavigate } from 'react-router-dom';
import toasted from '../config/toasted';
import SEO from '../config/SEO';
import { doc, getDoc, setDoc } from 'firebase/firestore';




const Login = () => {

     const navigate = useNavigate();


     function generatePanStyleID() {
          const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
          const numbers = "0123456789";

          // Pehle 5 random letters generate karo
          let part1 = "";
          for (let i = 0; i < 5; i++) {
               part1 += letters.charAt(Math.floor(Math.random() * letters.length));
          }

          // Beech ke 4 random numbers
          let part2 = "";
          for (let i = 0; i < 4; i++) {
               part2 += numbers.charAt(Math.floor(Math.random() * numbers.length));
          }

          // Akhiri 1 random letter
          let part3 = letters.charAt(Math.floor(Math.random() * letters.length));

          return part1 + part2 + part3;
     }

     const handleGoogleLogin = async () => {
          try {
               const result = await signInWithPopup(auth, provider);
               const user = result.user;


               if (!user.token) {

                    const userData = {
                         uid: user.uid,
                         name: user.displayName,
                         email: user.email,
                         photoURL: user.photoURL,
                         token: await user.getIdToken(),
                         createdAt: user.metadata.creationTime,
                         lastSignInTime: user.metadata.lastSignInTime,
                         phoneNumber: user.phoneNumber || null,
                         providerId: user.providerId,
                    };

                    localStorage.setItem("token", JSON.stringify(userData.token));
                    localStorage.setItem("user", JSON.stringify(userData));
                    localStorage.setItem("userID", JSON.stringify(userData.uid));
                    localStorage.setItem("auth", true);

                    navigate("/account");
                    toasted.success("Login successfully")

                    async function syncUserToFirestore(user) {
                         const userRef = doc(db, "users", user.uid);
                         const snap = await getDoc(userRef);

                         if (!snap.exists()) {
                              // FIRST TIME USER → CREATE
                              await setDoc(userRef, {
                                   uid: user.uid,
                                   username: generatePanStyleID(),
                                   subscriptions: 'free',
                                   prompt: 0,
                                   generation_credits: 1000,
                                   dailyClaimAt: null,
                                   isVerified: false,
                                   name: user.displayName || "",
                                   email: user.email || "",
                                   photoURL: user.photoURL || "",
                                   phoneNumber: user.phoneNumber || null,
                                   providerId: user.providerData[0]?.providerId || "",
                                   createdAt: user.metadata.creationTime,
                                   lastSignIn: user.metadata.lastSignInTime,
                                   lastUpdate: Date.now(),
                              });
                         } else {
                              // RETURNING USER → ONLY UPDATE LAST LOGIN
                              await setDoc(userRef, {
                                   lastSignIn: user.metadata.lastSignInTime,
                              }, { merge: true });
                         }
                    }


                    await syncUserToFirestore(user);



               }


          } catch (error) {
               console.error("Login error:", error);
               toasted.error("Login failed. Please try again.");
          }
     };

     useEffect(() => {
          const loggedIn = localStorage.getItem('auth') || localStorage.getItem('user');
          if (loggedIn) {
               navigate("/account");
          }
     }, [navigate])

     return (
          <>
               <SEO
                    title="Login"
                    description="Login to your HeyPrompt account to manage and submit AI prompts."
               />

               <div className="login-auth">
                    <div className="login-auth-card">
                         <h2 className="text-center mb-3">Welcome Back!</h2>
                         <h5 className="text-center mb-3">Sign in to continue</h5>
                         <p className="text-center mb-4">
                              Access your prompts, save your favorites, and explore the community content.
                         </p>
                         <button
                              className="btn"
                              onClick={handleGoogleLogin}
                         >
                              <img
                                   src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
                                   alt="Google"
                                   style={{ width: "20px", marginRight: "8px" }}
                              />
                              Continue with Google
                         </button>
                    </div>
               </div>
          </>
     );
}

export default Login;
